export default __webpack_public_path__ + "static/hp-brand-deck-18-9d8d1719b33041a5edef7d0cb14151b0.png";